// extracted by mini-css-extract-plugin
export default {"container":"TopMenuProfileTop_container__F+MVF","container_right_icons":"TopMenuProfileTop_container_right_icons__u25u+"};